export interface User {
  username: string;
  firstname: string;
  lastname: string;
}

export function createUser(params: Partial<User>) {
  return {
    ...params
  } as User;
}
